import { render, staticRenderFns } from "./chat-service.vue?vue&type=template&id=4c0026b9&scoped=true"
import script from "./chat-service.vue?vue&type=script&lang=js"
export * from "./chat-service.vue?vue&type=script&lang=js"
import style0 from "./chat-service.vue?vue&type=style&index=0&id=4c0026b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0026b9",
  null
  
)

export default component.exports